
<!--<p-blockUI [blocked]="true"></p-blockUI>-->

<form [formGroup]="form" class="container-fluid" autocomplete="off" id="homebackground">
    <div class="animated fadeIn">

        <div class="row justify-content-md-center center-login">
            <div class="col-md-4">

                <div class="card">
                    <div class="card-header">
                        <strong>Login Desarrollo (sin CAS)</strong>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-6">
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label required-field" for="impIdentificadorUsuario">Identificador de Usuario</label>
                                        <input formControlName="IdentificadorUsuario" (keydown.enter)="onKeydown()" name="Descripcion" title="" class="form-control"
                                               [ngClass]="displayFieldCss('IdentificadorUsuario')" id="inpIdentificadorUsuario" maxlength="9" type="text" value="">

                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('IdentificadorUsuario','required')">
                                            Identificador de Usuario es obligatorio
                                        </div>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">

                                            <div class="btn-group">
                                                <button class="btn btn-sm" type="button" title="Login en la aplicación" (click)="onLogin()"><i class="fa fa-sign-in"></i> Aceptar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="visibilityIniciando" class="form-group col-md-6">
                                <div class="row justify-content-md-center">
                                    <h5>Iniciando sesión...</h5>
                                </div>
                                <div class="row justify-content-md-center">
                                    <p-progressSpinner></p-progressSpinner>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>

        <!--https://medium.com/@schneidenbach/restful-api-best-practices-and-common-pitfalls-7a83ba3763b5-->
        <!--https://stackoverflow.com/questions/46434313/angular-4-async-with-loading-and-display-when-empty-->

    </div>

</form>
